import { render } from "./ForumList.vue?vue&type=template&id=b510dca4&scoped=true"
import script from "./ForumList.vue?vue&type=script&lang=js"
export * from "./ForumList.vue?vue&type=script&lang=js"

import "./ForumList.vue?vue&type=style&index=0&id=b510dca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b510dca4"]])

export default __exports__